import React from "react";
import { Dropdown } from "react-bootstrap";
import useAuth from "../../hooks/useAuth.js";
import { domainConfig } from "../../config.js";
import { openHelpCenter } from "../help/helpCenterEvents.js";

const NavbarUser = () => {
  const auth = useAuth();

  if (auth.isAuthenticated === true && Number(auth.tipo) !== 1) return null;

  return (
    <Dropdown className="nav-item" align="end">
      <span className="d-inline-block">
        <Dropdown.Toggle as="a" className="nav-link">
          <img
            src={domainConfig.imageServer + "/avatar.png"}
            className="avatar img-fluid rounded-circle me-1"
            alt="Foto"
          />
          <span className="text-dark d-sm-inline d-none">{auth.nome}</span>
        </Dropdown.Toggle>
      </span>
      <Dropdown.Menu drop="end">
        <Dropdown.Item onClick={() => openHelpCenter()}>Ajuda</Dropdown.Item>
        <Dropdown.Item onClick={auth.signOut}>Sair</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NavbarUser;
